import React from 'react';
import {
  List as RaList,
  useGetIdentity,
} from 'react-admin';

import { usePageTitle } from '../../../components/usePageTitle';
import { withPermissions } from '../../../components/hoc/WithPermissions';
import { USER_TYPE } from '../../../constants/statuses';
import { Filter } from './Filter';
import UserCardList from '../Components/userCardList';

const List = (props) => {
  usePageTitle(props);
  const { loading: identityLoading } = useGetIdentity();

  if (identityLoading) {
    return null;
  }

  return (
    <RaList
      {...props}
      sort={{ field: 'id', order: 'DESC' }}
      filters={<Filter />}
      bulkActionButtons={false}
    >
      <UserCardList {...props} />
    </RaList>
  );
};
export default withPermissions(List, [USER_TYPE.MANAGER, USER_TYPE.WORKER], null);
